import React, { useState } from 'react';
import { f7, Page, Link, Button, Input, Icon } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';

const ProfileUpdatePage = () => {
  const [card_number, setCardNum] = useState('');
  const [card_holder_name, setCardName] = useState('');
  const [cvv, setCVV] = useState('');
  const [expire_date, setExpDate] = useState('');
  const rest_id = localStorage.getItem('id');
  const issetpayment = '0';

  // const data = 
  const handleSubmit = (event) => {
    event.preventDefault();
    axios.post(API_BASE_URL + 'restwallet', { rest_id, card_number, card_holder_name, cvv, expire_date, issetpayment} , {
      headers: {
        'Authorization': 'Basic ' + API_AUTH
      }
    })
      .then(response => {f7.toast.create({
        text: 'Wallet Information added..!',
        position: 'top',
        cssClass: 'bg-color-teal',
        closeTimeout: 3000
      }).open()
      f7.views.main.router.navigate('/wallet/');
    })
      .catch(error => f7.toast.create({
        text: 'Check the card number..!',
        position: 'top',
        cssClass: 'bg-color-red',
        closeTimeout: 3000
      }).open());
  }
  return (
    <Page className='bg-white'>
      {/* <Navbar title="Restaurant Information" backLink="Back" noShadow/>             */}
      <div className='container'>
        <header className="section-t-space">
          <div className="custom-container">
            <div className="header-panel">
              <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
              <h2>Add New Card</h2>
            </div>
          </div>
        </header>
        <section className="section-b-space">
          <div className="custom-container">
            <div className="debit-card">
              <div className="card-details">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="card-name fw-semibold">CREDIT CARD</h5>
                  <img src={require("./../img/icon/network.svg").default} alt="network" />
                </div>
                <img className="img-fluid chip" src={require("./../img/icon/Chip.svg").default} alt="chip" />
                <ul className="ac-details">
                  <li>
                    <h6>AC No.</h6>
                    <h3>{card_number}</h3>
                  </li>
                  <li>
                    <h6>CVV</h6>
                    <h3>{cvv}</h3>
                  </li>
                  <li>
                    <h6>Exp.</h6>
                    <h3>{expire_date}</h3>
                  </li>
                </ul>
                <div className="user-name">
                  <h6>Name</h6>
                  <h5>{card_holder_name}</h5>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-b-space pt-0">
          <div className="custom-container">
            <form className="auth-form address-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label fw-semibold">Card Number</label>
                <div className="form-input mb-4">
                  <Input type="text" className="form-control" required validate pattern="[0-9\s]{12,18}" errorMessage="Please enter valid card number." placeholder="Enter card number" onInput={(event) => setCardNum(event.target.value)}/>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label fw-semibold">Card Holder Name</label>
                <div className="form-input mb-4">
                  <input type="text" className="form-control" placeholder="Enter card holder name" onInput={(event) => setCardName(event.target.value)}/>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label className="form-label fw-semibold">CVV</label>
                    <div className="form-input mb-3"><Input type="text" required validate pattern="[0-9\s]{3}" errorMessage="Please enter valid CVV number." className="form-control" placeholder="Enter cvv" onInput={(event) => setCVV(event.target.value)}/></div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label className="form-label fw-semibold">Exp. Date</label>
                    <div className="form-input mb-3">
                      <Input type="text" className="form-control" required validate pattern="(0|1)[0-9]\/[0-9]{2}" placeholder="MM/YY" onInput={(event) => setExpDate(event.target.value)}/>
                    </div>
                  </div>
                </div>
              </div>
              {/* <a href="payment-method.html" className="btn theme-btn w-100">Add Card</a> */}
              <Button className="btn theme-btn w-100" large type="submit">Add Card</Button>
            </form>
          </div>
        </section> 
      </div>   
    </Page>
  );
}

export default ProfileUpdatePage;